const FreeDishAddedNotification = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.button = this.querySelector(".free-dish-message--close");
    this.button.addEventListener("click", () => this.classList.remove("Active"));
    this.popupTrigger = this.querySelector(".free-dish-message__popup-trigger");
    this.popupTrigger.addEventListener("click", this.showPopup.bind(this));
    if (CookiesHelper.readCookie("freeDish")) {
      // setTimeout(() => {
      //   this.classList.add("Active");
      // }, 2000).bind(this);
    }
  }
  showPopup() {
    let popup = document.querySelector("free-dish-popup");
    popup.show();
  }
};

if (!window.customElements.get("free-dish-message")) {
  window.customElements.define("free-dish-message", FreeDishAddedNotification);
}



const FreeDishPopup = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initPopup();
    this.closeButton = this.querySelector(".free-dish-popup__close-button");
    this.overlay = this.querySelector(".free-dish-popup__overlay");
    this.closeButton.addEventListener("click", this.hide.bind(this));
    this.overlay.addEventListener("click", this.hide.bind(this));
  }
  initPopup() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show() {
    this.style.display = "flex";
  }
  hide() {
    this.style.display = "none";
  }
};

if (!window.customElements.get("free-dish-popup")) {
  window.customElements.define("free-dish-popup", FreeDishPopup);
}